import Vue from 'vue';
import store from './store'
import ElementUI from 'element-ui';
import vuescroll from 'vuescroll';
import router from './router.js'
import App from './App.vue';
import BaiduMap from 'vue-baidu-map'
import 'vuescroll/dist/vuescroll.css';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/app.css';
import 'animate.css';
import './assets/iconfont/iconfont.css'

Vue.use(ElementUI);
Vue.use(vuescroll);
Vue.use(router);
Vue.use(BaiduMap,{ak: '2t3BGjIIAvm54e3hStHQZcvvnxcuNGLT'});
Vue.config.productionTip = false;

Vue.prototype.pl=function(log){
  window.console.log(log)
}

Vue.directive('title',{
  inserted:function(el,binding){
    document.title = el.dataset.title
  }
})
new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
